export default "__VITE_ASSET__DfTxTf6b__"